import produce from 'immer'

import { Types } from './actions'

export const INITIAL_STATE = {
  loadings: {
    postLogin: false
  },
  errors: {
    postLogin: false
  },
  loginData: {
    attempts: 0,
    campaignId: null
  }
}

export default function loginReducers (state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case Types.postLogin: {
        draft.loadings.postLogin = true
        draft.loginData = { ...state.loginData, ...{ attempts: draft.loginData.attempts + 1 } }
        break
      }
      case Types.mtkLogin: {
        draft.loadings.postLogin = true
        draft.loginData = {
          ...state.loginData,
          ...{
            attempts: draft.loginData.attempts + 1,
            campaignId: action.payload.campaignId || ''
          }
        }
        break
      }
      case Types.getStoresByCPF: {
        draft.loadings.postLogin = true
        draft.loginData = { ...state.loginData, ...{ attempts: draft.loginData.attempts + 1 } }
        break
      }
      case Types.updateLoginData: {
        draft.loadings.postLogin = false
        draft.errors.postLogin = action?.payload?.error || false
        if (action.payload?.loginData) {
          draft.loginData = { ...state.loginData, ...action.payload?.loginData }
        }
        break
      }
      case Types.updateLogoff: {
        draft.loadings.postLogin = false
        draft.errors.postLogin = false
        draft.loginData = {
          attempts: 0,
          login: state.loginData.login,
          password: state.loginData.password
        }
        break
      }
      case Types.reset: {
        localStorage.removeItem('accessToken')
        localStorage.removeItem('refreshToken')
        Object.keys(INITIAL_STATE).forEach(key => {
          draft[key] = INITIAL_STATE[key]
        })
        break
      }
      default:
    }
  })
}
